<template>
  <v-container class="product-group-dialog-content">
    <v-row>
      <v-col cols="4">
        <div v-if="productGroup.image_url" class="image-container mb-2">
          <img :src="productGroup.image_url" alt="" />
        </div>
        <span class="header-image-title">Selecione a imagem do grupo de produtos </span>
        <mf-image-cropper
          class="mt-4"
          :mb-size-limit="0.5"
          :upload-image="modifyImg"
          :error-message="imageUrlError"
          :url="productGroup.image_url"
          :width="100"
          :height="100"
          show-hint
          @remove-image="deleteFile"
          @snackbar="showSnackbar"
        />
      </v-col>
      <v-col cols="8">
        <v-row>
          <v-col cols="10" class="py-0">
            <v-text-field v-model="productGroup.name" dense outlined label="Nome do grupo" :error-messages="nameError" />
          </v-col>
          <v-col cols="2" class="py-0">
            <mf-toggle v-model="productGroup.active" label="Ativo" class="pl-1 mt-4" hide-details />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4" class="py-0">
            <mf-number-input
              v-model="productGroup.trigger_value"
              label="Valor para creditar números da sorte"
              prefix="R$"
              type="text"
              dense
              is-float
              :error-messages="triggerValueError"
            />
          </v-col>
          <v-col cols="4" class="py-0">
            <mf-number-input
              v-model.lazy="productGroup.acceleration_value"
              label="Números da sorte extras"
              type="number"
              integer
              dense
              :value="productGroup.acceleration_value"
              :error-messages="accelerationValueError"
              @keydown="preventDefault($event, 'keydown')"
            />
          </v-col>
          <v-col cols="4" class="py-0">
            <v-text-field
              v-model="productGroup.max_per_coupon_value"
              outlined
              label="Máximo de números extras por compra"
              placeholder="Sem limitação"
              type="number"
              dense
              :error-messages="maxPerCouponValueError"
              @keydown="preventDefault($event, 'keydown')"
            />
          </v-col>
        </v-row>
        <v-divider class="my-2" />
        <v-row>
          <v-col cols="12" class="py-0">
            <product-group-products-table :products.sync="productGroup.products" :error-messages="productsError" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { MUTATION_SINGLE_UPLOAD_BASE64 } from '@/graphql'
import { minLength, required, minValue } from 'vuelidate/lib/validators'
import ProductGroupProductsTable from './ProductGroupProductsTable'
import { preventNumberEvents } from '../../helpers'
export default {
  name: 'ProductGroupDialogContent',
  components: {
    ProductGroupProductsTable,
  },
  props: {
    value: {
      type: Object,
    },
  },
  data: () => ({
    productGroup: {
      image_url: '',
      products: [],
      name: '',
      trigger_value: 0,
      acceleration_value: 0,
      max_per_coupon_value: null,
      active: true,
    },
  }),
  computed: {
    nameError() {
      if (this.$v.productGroup?.$error) {
        if (!this.$v.productGroup?.name?.required) return 'Preencha o nome do grupo.'
        if (!this.$v.productGroup?.name?.minLength) return 'O nome do grupo deve ter ao menos 2 caracteres.'
      }
      return ''
    },
    imageUrlError() {
      if (this.$v.productGroup?.image_url?.$error) return 'Configure uma imagem para o grupo.'
      return ''
    },
    triggerValueError() {
      if (this.$v.productGroup?.$error) {
        if (!this.$v.productGroup?.trigger_value?.required) return 'Preencha o valor.'
        if (!this.$v.productGroup?.trigger_value?.minValue) return 'O valor precisa ser ao menos R$ 0,01.'
      }
      return ''
    },
    accelerationValueError() {
      if (this.$v.productGroup?.$error) {
        if (!this.$v.productGroup?.acceleration_value?.required) return 'Preencha o valor.'
        if (!this.$v.productGroup?.acceleration_value?.minValue) return 'O valor precisa ser ao menos 1.'
      }
      return ''
    },
    maxPerCouponValueError() {
      if (this.$v.productGroup?.$error) {
        if (!this.$v.productGroup?.max_per_coupon_value?.minValue) return 'Se preenchido, o valor deve ser maior do que 0.'
      }
      return ''
    },
    productsError() {
      if (this.$v.productGroup?.$error) {
        if (!this.$v.productGroup?.products?.required) return 'É necessário configurar ao menos um produto no grupo.'
      }
      return ''
    },
  },
  watch: {
    dialog(value) {
      if (!value) this.productGroup = {}
    },
    value(value) {
      if (value) this.productGroup = value
    },
    productGroup: {
      deep: true,
      handler(value) {
        this.$emit('input', value)
      },
    },
  },
  mounted() {
    if (this.value) this.productGroup = this.value
  },
  methods: {
    validate() {
      this.$v.$reset()
      this.$v.$touch()

      return this.$v.$error
    },
    showSnackbar(snackbar) {
      this.$snackbar(snackbar)
    },
    deleteFile() {
      this.productGroup.image_url = ''
    },
    async modifyImg({ base64, filename }) {
      await this.$apollo
        .mutate({
          mutation: MUTATION_SINGLE_UPLOAD_BASE64,
          variables: {
            filename,
            base64,
          },
        })
        .then(({ data: { singleUploadBase64 } }) => {
          const { url } = singleUploadBase64
          this.productGroup.image_url = url
        })
    },
    preventDefault(event, type) {
      return preventNumberEvents(event, type)
    },
  },
  validations: {
    productGroup: {
      name: {
        required,
        minLength: minLength(2),
      },
      image_url: {
        required,
        minLength: minLength(2),
      },
      trigger_value: {
        required,
        minValue: minValue(0.01),
      },
      acceleration_value: {
        required,
        minValue: minValue(1),
      },
      max_per_coupon_value: {
        minValue: minValue(1),
      },
      products: {
        required,
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.product-group-dialog-content {
  .image-container {
    width: 100%;

    img {
      display: block;
      width: 100%;
    }
  }

  .header-image-title {
    color: $cinza-d10;
    font-family: Lato;
    font-size: 18px;
    font-weight: 700;
  }
}
</style>
